export const items = [
    "Order ID",
    "Ordered on",
    "Shop Products",
    "Address",
    "Tracking Number",
  ];